
import { BeginTrackingCookie, ConsentBannerAcceptedCookie, getCookie, setCookie } from '@/helpers/utils/cookies';
import { defineComponent, ref, onBeforeMount, onBeforeUnmount } from 'vue';

export default defineComponent({
  name: 'AcreCookieConsent',
  props: {
    maxWidthContainer: {
      type: Number,
      default: 600,
    },
    linkText: {
      type: String,
      default: 'Privacy Policy',
    },
    linkHref: {
      type: String,
      default: '/company/privacy',
    },
    message: {
      type: String,
      default: 'This site uses third-party cookies and tracking technologies to deliver its services and analyze traffic. These third parties may use your information for their own purposes, as described in our Privacy Policy.',
    },
    dismissButtonText: {
      type: String,
      default: 'Ok. Got it.',
    },
    cookieName: {
      type: String,
      default: ConsentBannerAcceptedCookie,
    },
    cookiePath: {
      type: String,
      default: '/',
    },
    cookieDomain: {
      type: String,
      default: '',
    },
    cookieExpiryDays: {
      type: Number,
      default: 365,
    },
  },
  emits: ['dismiss-cookie'],
  setup(props, { emit }) {
    const showPopup = ref(true);

    const beginTracking = () => setCookie(BeginTrackingCookie, 1, 365, '', '/');

    function acceptConsentBanner() {
      showPopup.value = false;
      emit('dismiss-cookie', showPopup.value);
      setCookie(props.cookieName, 1, props.cookieExpiryDays, props.cookieDomain, props.cookiePath);
      beginTracking();
    }

    onBeforeMount(() => {
      showPopup.value = !getCookie(props.cookieName);
    });

    const trackingTimeout = setTimeout(beginTracking, 6000);
    onBeforeUnmount(() => clearTimeout(trackingTimeout));

    return {
      showPopup,
      acceptConsentBanner,
    };
  },
});
